import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g stroke-miterlimit=\"10\" stroke-width=\"1.5\"><circle cx=\"6.1\" cy=\"12\" r=\"4.1\"></circle><circle cx=\"6.1\" cy=\"12\" r=\"4.1\"></circle><circle cx=\"17.9\" cy=\"5.3\" r=\"4.1\"></circle><circle cx=\"17.9\" cy=\"18.7\" r=\"4.1\"></circle><path d=\"m9.6 14 4.8 2.8M9.6 10l4.8-2.7\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }